"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _polished = require("polished");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // @ts-check
var getCustomStyles = function getCustomStyles(_ref) {
  var backgroundColor = _ref.backgroundColor,
    backgroundColorDisabled = _ref.backgroundColorDisabled,
    backgroundColorHover = _ref.backgroundColorHover,
    borderColorHover = _ref.borderColorHover,
    borderColor = _ref.borderColor,
    borderColorDisabled = _ref.borderColorDisabled,
    borderColorError = _ref.borderColorError,
    borderColorFocus = _ref.borderColorFocus,
    borderWidth = _ref.borderWidth,
    controlFocusBoxShadow = _ref.controlFocusBoxShadow,
    dropdownIndicatorColor = _ref.dropdownIndicatorColor,
    dropdownIndicatorColorDisabled = _ref.dropdownIndicatorColorDisabled,
    fontFamily = _ref.fontFamily,
    headingBorderColor = _ref.headingBorderColor,
    headingBorderSize = _ref.headingBorderSize,
    headingBorderStyle = _ref.headingBorderStyle,
    headingMargin = _ref.headingMargin,
    headingPadding = _ref.headingPadding,
    headingTextColor = _ref.headingTextColor,
    headingTextFontSize = _ref.headingTextFontSize,
    headingTextFontWeight = _ref.headingTextFontWeight,
    indicatorsContainerPaddingHorizontal = _ref.indicatorsContainerPaddingHorizontal,
    inputBoxSizeDefault = _ref.inputBoxSizeDefault,
    inputBoxSizeLarge = _ref.inputBoxSizeLarge,
    inputBoxSizeSmall = _ref.inputBoxSizeSmall,
    inputColor = _ref.inputColor,
    menuBackgroundColor = _ref.menuBackgroundColor,
    menuBorderColor = _ref.menuBorderColor,
    menuBorderSize = _ref.menuBorderSize,
    menuBorderStyle = _ref.menuBorderStyle,
    menuBoxShadowColor = _ref.menuBoxShadowColor,
    menuBoxShadowSize = _ref.menuBoxShadowSize,
    menuZindex = _ref.menuZindex,
    noOptionTextColor = _ref.noOptionTextColor,
    noOptionTextFontSize = _ref.noOptionTextFontSize,
    optionActiveBackgroundColor = _ref.optionActiveBackgroundColor,
    optionHoveredBackgroundColor = _ref.optionHoveredBackgroundColor,
    optionPaddingHorizontal = _ref.optionPaddingHorizontal,
    optionPaddingVertical = _ref.optionPaddingVertical,
    optionSelectedBackground = _ref.optionSelectedBackground,
    optionTextColor = _ref.optionTextColor,
    optionTextFontSize = _ref.optionTextFontSize,
    optionTextFontWeightSelected = _ref.optionTextFontWeightSelected,
    optionTextSelectedColor = _ref.optionTextSelectedColor,
    placeholderTextColor = _ref.placeholderTextColor,
    placeholderTextColorDisabled = _ref.placeholderTextColorDisabled,
    selectedOptionTextColor = _ref.selectedOptionTextColor,
    selectedOptionTextColorDisabled = _ref.selectedOptionTextColorDisabled,
    valueContainerPadding = _ref.valueContainerPadding;
  var getOptionTextStyles = function getOptionTextStyles(isSelected) {
    if (isSelected) {
      return {
        color: optionTextSelectedColor,
        fontWeight: optionTextFontWeightSelected
      };
    }
    return {
      color: optionTextColor
    };
  };
  var getBorderColor = function getBorderColor(_ref2) {
    var isDisabled = _ref2.isDisabled,
      isFocused = _ref2.isFocused,
      hasError = _ref2.hasError;
    if (isDisabled) {
      return borderColorDisabled;
    }
    if (hasError) {
      return borderColorError;
    }
    if (isFocused) {
      return borderColorFocus;
    }
    return borderColor;
  };
  var getHoverBorderColor = function getHoverBorderColor(_ref3) {
    var isDisabled = _ref3.isDisabled,
      isFocused = _ref3.isFocused,
      hasError = _ref3.hasError;
    if (isDisabled) {
      return borderColorDisabled;
    }
    if (hasError) {
      return borderColorError;
    }
    if (isFocused) {
      return borderColorFocus;
    }
    return borderColorHover;
  };
  var getSize = function getSize(size) {
    if (size === 'large') {
      return inputBoxSizeLarge;
    }
    if (size === 'small') {
      return inputBoxSizeSmall;
    }
    return inputBoxSizeDefault;
  };
  /**
   * Since the Indicators are no longer vertically centered they need to be aligned with the Icon, the Value and the
   * Chips (for multi-select). This calculates an appropriate padding for each size and also takes into account Classic
   *  which requires some padding for "small"
   * */
  var getIndicatorsContainerPadding = function getIndicatorsContainerPadding(size, iconSet) {
    if (size === 'large') {
      return '10px';
    }
    if (size === 'small') {
      if (iconSet === 'classic') {
        return '3px';
      }
      return '2px';
    }
    return '6px';
  };
  var getOptionBackground = function getOptionBackground(_ref4) {
    var isFocused = _ref4.isFocused,
      isSelected = _ref4.isSelected;
    if (optionSelectedBackground === 'icon' && isSelected && !isFocused) {
      return 'transparent';
    }
    if (isFocused || isSelected) {
      return optionHoveredBackgroundColor;
    }
    return 'transparent';
  };
  return {
    control: function control(providedStyle, _ref5) {
      var isDisabled = _ref5.isDisabled,
        isFocused = _ref5.isFocused,
        _ref5$selectProps = _ref5.selectProps,
        size = _ref5$selectProps.size,
        hasError = _ref5$selectProps.hasError;
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        ':hover': {
          background: backgroundColorHover,
          borderColor: getHoverBorderColor({
            isDisabled: isDisabled,
            isFocused: isFocused,
            hasError: hasError
          })
        },
        borderWidth: borderWidth,
        borderColor: getBorderColor({
          isDisabled: isDisabled,
          isFocused: isFocused,
          hasError: hasError
        }),
        background: isDisabled ? backgroundColorDisabled : backgroundColor,
        minHeight: getSize(size),
        boxShadow: isFocused ? controlFocusBoxShadow : undefined,
        cursor: !isDisabled && !isFocused && 'pointer'
      });
    },
    dropdownIndicator: function dropdownIndicator(providedStyle, _ref6) {
      var isDisabled = _ref6.isDisabled;
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        color: isDisabled ? dropdownIndicatorColorDisabled : dropdownIndicatorColor
      });
    },
    groupHeading: function groupHeading(providedStyle) {
      return _objectSpread(_objectSpread(_objectSpread({}, providedStyle), (0, _polished.ellipsis)()), {}, {
        fontFamily: fontFamily,
        fontSize: headingTextFontSize,
        fontWeight: headingTextFontWeight,
        textAlign: 'initial',
        textTransform: undefined,
        color: headingTextColor,
        display: 'block',
        borderBottom: "".concat(headingBorderSize, " ").concat(headingBorderStyle, " ").concat(headingBorderColor),
        padding: headingPadding,
        margin: headingMargin
      });
    },
    indicatorSeparator: function indicatorSeparator(providedStyle) {
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        display: 'none'
      });
    },
    indicatorsContainer: function indicatorsContainer(providedStyle, _ref7) {
      var _ref7$selectProps = _ref7.selectProps,
        size = _ref7$selectProps.size,
        iconSet = _ref7$selectProps.iconSet;
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        alignSelf: 'center',
        padding: "".concat(getIndicatorsContainerPadding(size, iconSet), " ").concat(indicatorsContainerPaddingHorizontal)
      });
    },
    input: function input(providedStyle) {
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        color: inputColor
      });
    },
    menu: function menu(providedStyle) {
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        boxShadow: "".concat(menuBoxShadowSize, " ").concat(menuBoxShadowColor),
        background: menuBackgroundColor,
        border: "".concat(menuBorderSize, " ").concat(menuBorderStyle, " ").concat(menuBorderColor),
        marginTop: 0,
        zIndex: "".concat(menuZindex)
      });
    },
    menuPortal: function menuPortal(providedStyle) {
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        zIndex: "".concat(menuZindex)
      });
    },
    noOptionsMessage: function noOptionsMessage(providedStyle) {
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        fontFamily: fontFamily,
        fontSize: noOptionTextFontSize,
        padding: "".concat(optionPaddingVertical, " ").concat(optionPaddingHorizontal),
        color: noOptionTextColor
      });
    },
    option: function option(providedStyle, state) {
      var isFocused = state.isFocused,
        isSelected = state.isSelected,
        isDisabled = state.isDisabled;
      return _objectSpread(_objectSpread(_objectSpread({}, providedStyle), {}, {
        fontFamily: fontFamily,
        fontSize: optionTextFontSize,
        position: 'relative',
        padding: "".concat(optionPaddingVertical, " ").concat(optionPaddingHorizontal),
        display: 'flex',
        alignItems: 'center',
        textAlign: 'initial',
        background: getOptionBackground({
          isFocused: isFocused,
          isSelected: isSelected
        })
      }, getOptionTextStyles(isSelected)), {}, {
        ':active': {
          background: optionActiveBackgroundColor
        },
        opacity: isDisabled ? 0.5 : undefined,
        cursor: isDisabled ? 'default' : 'pointer'
      });
    },
    placeholder: function placeholder(providedStyle, _ref8) {
      var isDisabled = _ref8.isDisabled,
        isSearchable = _ref8.selectProps.isSearchable;
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        fontSize: optionTextFontSize,
        color: isDisabled ? placeholderTextColorDisabled : placeholderTextColor,
        top: 0,
        transform: 0,
        position: isSearchable ? 'absolute' : 'relative'
      }, (0, _polished.ellipsis)());
    },
    singleValue: function singleValue(providedStyle, _ref9) {
      var isDisabled = _ref9.isDisabled,
        isSearchable = _ref9.selectProps.isSearchable;
      return _objectSpread(_objectSpread({}, providedStyle), {}, {
        color: isDisabled ? selectedOptionTextColorDisabled : selectedOptionTextColor,
        top: 0,
        transform: 0,
        position: isSearchable ? 'absolute' : 'relative'
      });
    },
    valueContainer: function valueContainer(providedStyle) {
      return _objectSpread(_objectSpread(_objectSpread({}, providedStyle), (0, _polished.ellipsis)()), {}, {
        padding: valueContainerPadding,
        display: 'flex',
        flexWrap: 'nowrap'
      });
    }
  };
};
var _default = getCustomStyles;
exports["default"] = _default;